"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.METHOD = void 0;
/** Supported signature methods */
var METHOD;
(function (METHOD) {
    METHOD["ECDSA"] = "ecdsa";
    METHOD["ECDSA_ETHEREUM"] = "ecdsa-ethereum";
})(METHOD || (exports.METHOD = METHOD = {}));
//# sourceMappingURL=signature-types.js.map